export function parseYMDLocal(s?: string | null): Date | null {
  if (!s) return null;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function monthKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; // e.g., 2025-10
}

export function monthLabel(d: Date): string {
  return `${d.getMonth() + 1}/${d.getFullYear()}`; // e.g., 10/2025
}

/**
 * Build a single-series time series from arbitrary records.
 */
export function buildMonthSeries<T>(
  rows: T[],
  opts: {
    dateAccessor: (row: T) => Date | null;
    valueAccessor: (row: T) => number;
  }
): { labels: string[]; data: number[] } {
  const buckets = new Map<string, { d: Date; sum: number }>();
  for (const r of rows) {
    const d = opts.dateAccessor(r);
    if (!d) continue;
    const key = monthKey(d);
    const entry = buckets.get(key) ?? { d, sum: 0 };
    entry.sum += Number(opts.valueAccessor(r) || 0);
    buckets.set(key, entry);
  }
  const ordered = Array.from(buckets.values()).sort(
    (a, b) => a.d.getTime() - b.d.getTime()
  );
  return {
    labels: ordered.map((x) => monthLabel(x.d)),
    data: ordered.map((x) => x.sum),
  };
}
